// Helpers for GET /companies/:id/acl — API envelope varies slightly; Autocomplete needs merged options.

export function normalizeAclUser(u) {
  if (!u || u.id == null) return null;
  return {
    id: Number(u.id),
    nome: String(u.nome ?? ""),
    email: String(u.email ?? ""),
  };
}

/** Unwrap users list from fetchData() response for company ACL. */
export function extractCompanyAclUsers(resp) {
  const d = resp?.data;
  if (!d) return [];
  let raw = [];
  if (Array.isArray(d.users)) raw = d.users;
  else if (Array.isArray(d)) raw = d;
  else if (d && Array.isArray(d.data?.users)) raw = d.data.users;
  return raw.map(normalizeAclUser).filter(Boolean);
}

/** Keeps selected chips visible even before search populates `options` (MUI Autocomplete). */
export function mergeAutocompleteUsers(searchHits, selected) {
  const m = new Map();
  [...(selected || []), ...(searchHits || [])].forEach((u) => {
    const n = normalizeAclUser(u);
    if (n) m.set(n.id, n);
  });
  return [...m.values()];
}
